import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'

import { ORGANIZATIONS, WISHLISTS } from '../../../../Utilities/APIs'
import { makeIntersectionArray } from '../../../../Utilities/FilterFunctions'
import OrganizationCard from '../../../Partials/Layouts/OrganizationCard/OrganizationCard'


function Wishlist() {

    const [organizations, setOrganizations] = useState(null);
    const {consumer} = useSelector(state => state.auth)

    const [toggleFetch, setToggleFetch] = useState(false)
    
    useEffect(() => {
        async function fetchMyWishlist() {

        const config = {
            headers: {
                Authorization: `Bearer ${consumer.token}`
            }
        }
        const {data} = await axios.get(WISHLISTS + 'myWishlist', config)

        const itemRes = await fetch(ORGANIZATIONS)
        const itemData = await itemRes.json()

        const wishlist = makeIntersectionArray(itemData, '_id', data, 'organization')
        // console.log(wishlist);

        const favList = wishlist.map(w => w = {...w, favorite: true})
        setOrganizations(favList);
    }

    fetchMyWishlist()
    }, [toggleFetch, consumer.token]);

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }

    return (
        <div className="favorites_wrapper">
            <div className="row organizations_cards">
                {organizations?.map(organization => (
                    <OrganizationCard
                        key={organization._id}
                        organization={organization}
                        triggerFetch={triggerFetch}
                    />
                ))}
            </div>
        </div>
    )
}

export default Wishlist